{
    "title": "Review Application",
    "subtitle": "Fix the application errors below to continue",
    "mobileadvice": "Finish your application review in a desktop browser",
    "field":{
        "firstName": "First name",
        "middleName": "Middle name",
        "lastName": "Last name",
        "dateOfBirth": "Date of Birth",
        "emailAddress": "E-mail",
        "telephoneNumber": "Telephone Number",
        "nationality": "Country of Residence",
        "taxReferenceNumber": "Tax Identification Number (TIN)",
        "passportNumber": "Passport Number",
        "usResidencyStatus": "Are you an US resident?",
        "countryCode": "Country",
        "state": "State",
        "city": "City",
        "occupation": "Occupation",
        "employmentStatus": "Employment Status",
        "employmentDescription": "Employment Description",
        "employerName": "Employer Name",
        "citizenship": "Citizenship",
        "addressLine1": "Address Line 1",
        "addressLine2": "Address Line 2",
        "addressLine3": "Address Line 3",
        "postalCode": "Postal Code",
        "unitNumber": "Unit Number",
        "registeredName": "Registered Name",
        "tradingName": "Trading Name",
        "registeredNumber": "Registered Number",
        "websiteAddress": "Website Address",
        "stateOfIncorporation": "State of Incorporation",
        "countryOfIncorporation": "Country of Incorporation",
        "corporateEntityType": "Corporate Entity Type",
        "establishedOn": "Established On",
        "naics": "Choose your commercial industry",
        "naicsDescription": "NAICS Description",
        "primaryBusiness": "Primary Business",
        "businessNature": "Nature of Business",
        "isCharitable": "Is an charitable institution?",
        "countriesJurisdictions": "Countries of Operation",
        "businessJurisdictions": "Countries in which your company operates",
        "fundsSendReceiveJurisdictions": "Funds and Receives Jurisdictions",
        "newYorkOffice": "Is the office located in New York?",
        "engageInActivities": "Does your business engage in any of the following activities?",
        "regulatedStatus": "Is your company regulated?",
        "regulationAgency": "Regulation Agency Name",
        "regulationAgencyNumber": "Regulation Agency Number",
        "controlExemptionReason": "Control Exemption Reason",
        "vendorsAndCounterparties": "Vendors and Counterparties",
        "primarySourceOfFunds": "Primary Source of Funds",
        "primarySourceOfFundsDescription": "Primary Source of Funds Description",
        "totalInvestableAssets": "Total Investable Assets",
        "totalAssets": "Total Assets",
        "assetAllocationToCrypto": "Asset Allocation to Crypto",
        "investmentExperienceCrypto": "Investment Experience in Crypto",
        "investmentStrategyCrypto": "Investment Strategy in Crypto",
        "initialDepositSource": "Initial Deposit Source",
        "initialDepositSourceCryptoDetails": "Initial Deposit Source - Crypto Details",
        "initialDepositSourceFiatDetails": "Initial Deposit Source - Fiat Details",
        "ongoingDepositSource": "Ongoing Deposit Source",
        "frequencyOfCryptoTransactions": "Frequency of Crypto Transactions",
        "cryptoInvestmentPlans": "Crypto Investment Plans",
        "investmentProceedsUse": "Investment Proceeds Use",
        "expectedCryptoAssets": "Expected Crypto Assets",
        "performTransfersWithUnhostedWallets": "Perform Transfers with Unhosted Wallets",
        "knownUnhostedWalletAddresses": "Known Unhosted Wallet Addresses",
        "tradesPerMonth": "Trades per Month",
        "usdValueOfCrypto": "Projected Monthly Digital Asset Trading Volume",
        "usdValueOfFiat": "Projected Monthly Fiat Transactional Volume",
        "frequencyOfTransactions": "Frequency of Transactions",
        "monthlyCryptoInvestmentDeposit": "Projected Monthly Digital Asset Deposit Amount",
        "monthlyInvestmentDeposit": "Projected Monthly Fiat Deposit Amount",
        "monthlyCryptoDeposits": "Projected Number of Total Monthly Digital Asset Deposit",
        "monthlyDeposits": "Projected Number of Incoming Bank Wires",
        "monthlyCryptoInvestmentWithdrawal": "Projected Monthly Digital Asset Withdrawal Volume",
        "monthlyInvestmentWithdrawal": "Projected Monthly Fiat Withdrawal Volume",
        "monthlyCryptoWithdrawals": "Projected Number of Total Monthly Digital Asset Withdrawal",
        "monthlyWithdrawals": "Projected Number of Total Monthly Fiat Withdrawal",
        "tradeInternationally": "Trade Internationally",
        "tradeJurisdictions": "Trade Jurisdictions",
        "descriptionOfBusinessNature": "Description of Business Nature"
    }
}